function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUud3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 18.71 17.97 C 18.883 18 19.209 18.09 19.382 18.09 C 20.946 18.079 22.205 16.749 22.194 15.12 C 22.21 13.487 20.949 12.151 19.382 12.14 L 19.19 12.14 M 5.055 12.14 C 3.552 12.246 2.392 13.56 2.416 15.13 C 2.405 16.759 3.664 18.089 5.228 18.1 L 5.669 18.1 M 5.055 12.16 L 2.416 4.8 L 7.32 5.75 L 10.477 1 L 15.035 4.4 L 19.219 1.8 L 19.209 12.15 M 5.065 12.15 C 5.065 13.25 5.199 15.48 5.199 15.48 C 5.272 19.435 8.409 22.578 12.204 22.5 C 16.152 22.565 19.347 19.172 19.209 15.06 L 19.209 12.15 M 5.065 12.15 L 19.209 9.64 M 8.865 18.62 C 9.775 19.408 10.925 19.834 12.108 19.82 C 14.152 19.82 15.947 18.61 16.542 16.82",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUud3);
export default __webpack_public_path__ + "static/media/uud3.d19e92a626cd5b0306cc14f7aaa3b00d.svg";
export { ForwardRef as ReactComponent };